
__webpack_require__.debugRequireIds = {
	"!!../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1/node_modules/css-loader/dist/cjs.js!./generated/emoji-styles/google-sprite.css": 30583,
	"!!../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1/node_modules/css-loader/dist/cjs.js!./generated/emoji-styles/twitter-sprite.css": 51157,
	"!style-loader?injectType=lazyStyleTag!css-loader!./generated/emoji-styles/google-sprite.css": 70690,
	"!style-loader?injectType=lazyStyleTag!css-loader!./generated/emoji-styles/twitter-sprite.css": 96010,
	"-!./debug-require.cjs": 2800,
	"-!jquery": 49949,
	"./debug-require.cjs": 13732,
	"./generated/emoji/google.webp": 94213,
	"./generated/emoji/twitter.webp": 60889,
	"./src/base_page_params.ts": 26087,
	"./src/blueslip.ts": 50489,
	"./src/blueslip_stacktrace.ts": 49437,
	"./src/bot_types.ts": 70176,
	"./src/bundles/common.ts": 6400,
	"./src/csrf.ts": 1933,
	"./src/i18n.ts": 44327,
	"./src/portico/google-analytics.ts": 9900,
	"./src/portico/portico_modals.ts": 23437,
	"./src/portico/tippyjs.ts": 95225,
	"./src/realm_user_settings_defaults.ts": 64199,
	"./src/sentry.ts": 21440,
	"./src/state_data.ts": 80645,
	"./src/stream_types.ts": 76113,
	"./src/types.ts": 14550,
	"./src/user_settings.ts": 50526,
	"./src/user_status_types.ts": 12623,
	"./src/util.ts": 36555,
	"./templates/blueslip_stacktrace.hbs": 24075,
	"@formatjs/fast-memoize": 75322,
	"altcha": 26971,
	"core-js/modules/es.array-buffer.detached.js": 39270,
	"core-js/modules/es.array-buffer.transfer-to-fixed-length.js": 51671,
	"core-js/modules/es.array-buffer.transfer.js": 16103,
	"core-js/modules/es.array.push.js": 64755,
	"core-js/modules/es.iterator.constructor.js": 94178,
	"core-js/modules/es.iterator.filter.js": 79342,
	"core-js/modules/es.iterator.find.js": 58471,
	"core-js/modules/es.iterator.map.js": 64792,
	"core-js/modules/es.iterator.some.js": 3380,
	"core-js/modules/es.json.stringify.js": 99811,
	"core-js/modules/es.set.difference.v2.js": 23029,
	"core-js/modules/es.set.intersection.v2.js": 22659,
	"core-js/modules/es.set.is-disjoint-from.v2.js": 54726,
	"core-js/modules/es.set.is-subset-of.v2.js": 9491,
	"core-js/modules/es.set.is-superset-of.v2.js": 57748,
	"core-js/modules/es.set.symmetric-difference.v2.js": 2715,
	"core-js/modules/es.set.union.v2.js": 69351,
	"core-js/modules/es.typed-array.with.js": 72260,
	"core-js/modules/esnext.json.parse.js": 22862,
	"core-js/modules/esnext.uint8-array.set-from-base64.js": 9386,
	"core-js/modules/esnext.uint8-array.set-from-hex.js": 61868,
	"core-js/modules/esnext.uint8-array.to-base64.js": 10460,
	"core-js/modules/esnext.uint8-array.to-hex.js": 90718,
	"core-js/modules/web.url-search-params.delete.js": 89584,
	"core-js/modules/web.url-search-params.has.js": 17535,
	"core-js/modules/web.url-search-params.size.js": 10418,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 81942,
	"jquery": 93576,
	"jquery-validation": 67232,
	"lodash": 25043,
	"micromodal": 98476,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"tippy.js": 99947,
	"tippy.js/dist/tippy.css": 96773,
	"zod/mini": 49020
};